import { Controller } from "@hotwired/stimulus"
import { Swiper } from 'swiper'
import { Navigation, Pagination, Autoplay } from 'swiper/modules'

// Connects to data-controller="featured-suppliers"
export default class extends Controller {
  static targets = ["container"]

  connect() {
    this.initSwiper()
  }

  disconnect() {
    if (this.swiper) {
      this.swiper.destroy(true, true)
    }
  }

  initSwiper() {
    this.swiper = new Swiper(this.containerTarget, {
      modules: [Navigation, Pagination, Autoplay],
      
      // Default settings
      slidesPerView: 1,
      spaceBetween: 20,
      
      // Responsive breakpoints
      breakpoints: {
        640: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 25,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 24,
        }
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      // Pagination dots
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        dynamicBullets: true,
      },

      // Autoplay
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },

      // Effects
      speed: 600,
      loop: true,
      
      // Accessibility
      a11y: {
        prevSlideMessage: 'Previous supplier',
        nextSlideMessage: 'Next supplier',
        paginationBulletMessage: 'Go to supplier {{index}}',
      },

      // Grab cursor
      grabCursor: true,
    })
  }
}